// src/components/PortfolioGrid.js
import React from "react";
import "./PortfolioGrid.css";
import { Button } from "./Button";
import { Link } from "react-router-dom";

function PortfolioCard({ project, onQuickView }) {
  return (
    <article className="pf-card">
      <div className="pf-thumb">
        <img
          src={project.cover}
          alt={project.title}
          loading="lazy"
          className="pf-img"
        />
        {project.tags?.length ? (
          <div className="pf-tags">
            {project.tags.map((t) => (
              <span key={t} className="pf-tag">{t}</span>
            ))}
          </div>
        ) : null}
      </div>

      <div className="pf-meta">
        <h3 className="pf-title">{project.title}</h3>
        {project.excerpt ? <p className="pf-excerpt">{project.excerpt}</p> : null}

        <div className="pf-actions">
          {project.slug && (
            <Link to={project.slug}>
              <Button
                className="btn-mobile"
                buttonStyle="btn--primary"
                buttonSize="btn--medium"
              >
                View Project
              </Button>
            </Link>
          )}

          {/* <Button
            className="btn-mobile"
            buttonStyle="btn--outline"
            buttonSize="btn--medium"
            onClick={() => onQuickView?.(project)}
          >
            Quick View
          </Button> */}
        </div>
      </div>
    </article>
  );
}

export default function PortfolioGrid({ items = [], onProjectClick }) {
  if (!items.length) {
    return (
      <div className="pf-empty">
        <p>No projects match this filter yet.</p>
      </div>
    );
  }

  return (
    <section className="pf-grid">
      {items.map((p) => (
        <PortfolioCard
          key={p.id || p.title}
          project={p}
          onQuickView={onProjectClick}
        />
      ))}
    </section>
  );
}
